import { t } from "i18next";
import { Violation } from "./penalty";

export class PenaltyCounts {
  transfer: number;
  violation: number;
  constructor(transfer: number, violation: number) {
    this.transfer = transfer;
    this.violation = violation;
  }

  print() {
    return `${t("userdetail_note_transfer")}: ${this.transfer}\n${t("userdetail_note_violation")}: ${this.violation}`;
  }
}

interface PenaltyStatusProps {
  tardy?: boolean;
  transfer?: Violation;
  violation?: Violation;
  counts?: PenaltyCounts;
}

export class PenaltyStatus {
  tardy: boolean;
  transfer?: Violation;
  violation?: Violation;
  counts: PenaltyCounts;

  constructor(props?: PenaltyStatusProps) {
    this.tardy = props?.tardy || false;
    this.transfer = props?.transfer;
    this.violation = props?.violation;
    this.counts = props?.counts || new PenaltyCounts(0, 0);
  }
}
